export const generalInfo = {
	title: "INFORMAÇÕES GERAIS",
	fields: {
		image: {
			label: "Imagem do produto",
			ariaLabel: "Upload product image",
		},
		name: {
			label: "Nome",
			placeholder: "Nome do produto",
		},
		productType: {
			label: "Tipo do produto",
			placeholder: "Selecione o tipo",
			loading: "Carregando...",
		},
		sku: {
			label: "SKU",
			placeholder: "Digite o SKU",
			tooltip:
				"SKU (Stock Keeping Unit) é um código único para identificar o produto. Se você não preencher, vamos gerar um automaticamente.",
		},
		category: {
			label: "Categoria",
			placeholder: "Selecione uma categoria",
			newCategoryWarning: "Você criará uma nova categoria",
			createOption: "Criar",
		},
		menuCategory: {
			label: "Categoria do menu",
			placeholder: "Selecione uma categoria do menu",
			newCategoryWarning: "Você criará uma nova categoria",
			createOption: "Criar",
		},
		preparationTime: {
			label: "Tempo de preparo",
			placeholder: "00 minutos",
			tooltip: "Informe o tempo que a cozinha leva para preparar este produto em minutos",
			unit: "minutos",
		},
		description: {
			label: "Descrição",
			placeholder: "Escreva uma descrição breve",
		},
		hasAlcohol: {
			label: "Contém álcool?",
			tooltip: "Quando ativado, aparecerá no cardápio para os clientes que contém álcool",
			yes: "sim",
			no: "não",
		},
		isHiddenFromApp: {
			label: "Exibir o produto no ZigApp?",
			yes: "sim",
			no: "não",
		},
	},
	noCategory: "Sem categoria",
	noCategoryFound: "Nenhuma categoria encontrada",
};
